$('.sitemap-toggler').on('click', function(){
  $('.sitemap-toggler img').toggleClass('d-none');
  setTimeout(function(){
    $(document).scrollTop($(document).innerHeight());
  }, 500);
});